import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import fileDownload from 'js-file-download';
import { findSequence, wrapperCall } from '../../utils.js';

const CustomAnchorComponentPrint = (params) => {
    const token = useSelector(state => state.auth.token);
    const navigate = useNavigate();
    const rowData = params.node['data'];
    const imageSource = rowData['imageSource'];

    const handleClick = async(event) => {
        event.preventDefault();
        try {
            const response = await wrapperCall(
                'djaa/imageSource', 
                imageSource, 
                token, 
                'arraybuffer',
                navigate
            );
            const contentType = response.headers['content-type'];
            const boundaryMatch = contentType.match(/boundary=(.*)/);

            if (!boundaryMatch) {
                throw new Error("Boundary not found in Content-Type header");
            }
            const boundary = `--${boundaryMatch[1]}`;
            const boundaryBytes = new TextEncoder().encode(boundary);
            const doubleCRLF = new Uint8Array([13, 10, 13, 10]); 
            const uint8Array = new Uint8Array(response.data);
            let start = 0;

            console.log(response.data);
            console.log("uint8Array length: " + uint8Array.length)

            while (start < uint8Array.length) {
                const end = findSequence(uint8Array, boundaryBytes, start);
                if (end === -1) break;
                const part = uint8Array.slice(start, end);
                const headersEndIndex = findSequence(part, doubleCRLF, 0);

                if (headersEndIndex === -1) {
                    start = end + boundaryBytes.length;
                    continue;
                }
    
                const headersPart = part.slice(0, headersEndIndex);
                const body = part.slice(headersEndIndex + doubleCRLF.length);
                const headers = new TextDecoder().decode(headersPart);

                console.log("Headers: " + headers);
    
                const filenameMatch = headers.match(/filename="(.+)"/);
                const filename = filenameMatch ? filenameMatch[1] : "file.bin";
                const contentTypeMatch = headers.match(/Content-Type: (.+)/);
                const contentType = contentTypeMatch ? contentTypeMatch[1] : "application/octet-stream";
    
                const blob = new Blob([body], { type: contentType });
                fileDownload(blob, filename);
                start = end + boundaryBytes.length;
            }
    
            console.log("Files downloaded successfully!");
        } catch (error) {
            console.log(error);
        } 
    }    

    return (
        (imageSource.length > 0) ?
        <a
            href="#"
            onClick={handleClick} 
        >
            View Image
        </a>
        :
        <p style={{  margin: 0, padding: 0 }}><u style={{ color:'blue' }}>No Image</u></p>
    );
};

const DJAALinesColumns = [
    { headerName: "Charge Type", field: "chargeType" },
    { headerName: "RA Number", field: "raNumber" },
    { headerName: "Brand", field: "brand" },
    { headerName: "Adj. Country", field: "adjCountry" },
    { headerName: "Country Charged", field: "chargedCountry" },
    { headerName: "Adj. Ref. No.", field: "adjRef" },
    { headerName: "Batch Ref.", field: "batchRef" },
    { headerName: "Billing Amount", field: "billAmt" },
    { headerName: "Renting Amount", field: "rentAmt" },
    { headerName: "Charge Period", field: "chargePeriod" },
    { headerName: "FX Adjustment", field: "fxAdj" },
    { headerName: "FX Gain/Loss", field: "fxGainLoss" },
    { headerName: "Recharge for Reason", field: "rechargeReason" },
    { headerName: "Image Now", field: "imageNowLink", hide: true },
    { headerName: "Suppporting Images", field: "imageSource", cellRenderer: CustomAnchorComponentPrint }
]

export default DJAALinesColumns;